module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<property-sheet class=\"prop-sheet\" params=\"properties: $data\"></property-sheet>\n";
